throw new Error(
	'The @rivetkit/actor package has been replaced by the "rivetkit" package. Please install "rivetkit" instead.',
);
